import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class PreviewItem extends PureComponent {
  render() {
    const { children, className, label, ...others } = this.props;
    const cls = classNames({
      "weui-form-preview__item": true
    }, className);

    return (
      <div className={ cls } { ...others }>
        {
          label && <label className="weui-form-preview__label">{ label }</label>
        }
        <span className="weui-form-preview__value">{ children }</span>
      </div>
    );
  }
}
